import { Component, Input, OnInit } from '@angular/core';
import { PanelHeaderTitle, SidePanelService } from '../../../services/side-panel.service';
import { INotification } from '../../../models/notifications';
import { NotificationsService } from '../../../services/notifications.service';
import { SnackBarService } from '../../../services/snack-bar.service';
import { TranslateService } from '@ngx-translate/core';

import { SHARED_MODULES } from '../../../../shared.';
import { GetLinkPipe } from '../../../pipes/get-link.pipe';
import { HasAccessPipe } from '../../../pipes/has-access.pipe';
import { PhIconComponent } from '../../ph-icon/ph-icon.component';
import { PhLoaderComponent } from '../../ph-loader/ph-loader.component';
import { SessionService } from '../../../services/session.service';

export const TITLES: Map<string, string> = new Map([
	['multi_execution', 'NOTIFICATIONS.EXECUTION_RESULTS'],
	['failed_multi_execution', 'NOTIFICATIONS.SCHEDULED_PLANOGRAMS.ERROR_SENDING'],
	['scheduled_execution', 'SCHEDULED_PLANOGRAMS.PLANNED_DATES'],
	['scheduled_executions_for_tomorrow', 'NOTIFICATIONS.SCHEDULED_PLANOGRAMS.ERROR_SENDING'],
	['DEADLINE_OVERDUE_ADMIN', 'DEADLINE.STANDS_WITH_OVERDUE'],
	['DEADLINE_OVERDUE_MANAGER', 'DEADLINE.STANDS_WITH_OVERDUE'],
	['DEADLINE_TODAY', 'PLANOGRAMS_TO_EXECUTE'],
	['DEADLINE_TOMORROW', 'PLANOGRAMS_TO_EXECUTE'],
	['etl_product_update', 'NOTIFICATIONS.DATA_UPDATE_RESULTS'],
	['share_planogram', 'NOTIFICATIONS.PLANOGRAM_COPY_RESULTS'],
	['rotation', 'NOTIFICATIONS.ROTATION_RESULTS'],
	['instrument_edit', 'NOTIFICATIONS.EQUIPMENT_EDIT_RESULTS'],
	['archive_products', 'COMMON.PRODUCT.ARCHIVING'],
    ['unarchive_products', 'COMMON.PRODUCT.UNARCHIVING'],
]);

@Component({
	selector: 'ph-notifications-detailed-panel[notification]',
	templateUrl: './ph-notifications-detailed-panel.component.html',
	styleUrls: ['./ph-notifications-detailed-panel.component.scss'],
	imports: [SHARED_MODULES, GetLinkPipe, HasAccessPipe, PhIconComponent, PhLoaderComponent],
	standalone: true
})
export class PhNotificationsDetailedPanelComponent implements OnInit {

	public showLoader: boolean = true;

	@Input() notification: INotification;

	constructor(
		private translate: TranslateService,
		private notificationsService: NotificationsService,
		private sidePanelService: SidePanelService,
        private sessionService: SessionService,
		private snackBarService: SnackBarService
	) {}

	ngOnInit(): void {
		this.sidePanelService.hasBackdrop = true;
		this.sidePanelService.backdropShadow = true;
		this.sidePanelService.showButtons = false;
		if (this.notification.type === 'scheduled_executions_for_tomorrow') {
			const tomorrow: Date = new Date(this.notification.created_at);
			tomorrow.setDate(tomorrow.getDate() + 1);
			const formattedDate = this.sessionService.formatDate(tomorrow, 'dd.MM.yyyy');

			this.sidePanelService.title = this.translate.instant('SCHEDULED_PLANOGRAMS.SCHEDULED_FOR_TOMORROW_BODY', {
				date: formattedDate
			});
		} else {
			this.sidePanelService.title = TITLES.get(this.notification.type) || PanelHeaderTitle.Notifications;
		}

		if (!this.notification.read) this.notificationsService.read({ ids: this.notification.id }).subscribe();

		if (!this.notification.data) {
			this.notificationsService.get(this.notification.id).subscribe({
				next: (notification: INotification) => {
					this.notification.data = notification.data;
					this.showLoader = false;
				},
				error: () => {
					this.snackBarService.setErrorNotification();
					this.sidePanelService.closeSubject.next();
				}
			});
		} else {
			setTimeout(() => this.showLoader = false, 500);
		}
	}

	public getNotFoundArticles(item: any): string {
		return item.errors.notFound
			.map(p => p.product_rotate_from.article)
			.join(', ');
	}
}
